<script>
import * as Helper from "@/modules/helper/index";
import closeUrl from '@/css/images/close.svg'
import DeviceInfo from '@/modules/util/deviceInfo'
import { mapGetters } from "vuex";
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    types: {
      type: Array,
      default: []
    },
    fileName: {
      type: String
    },
    index: {
      type: Number,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: "" // default
    }
  },
  data: function() {
    return {
      isInputActive: false,
      filename: ""
    };
  },
  filters: {
    splitFileName: function (value) {
      if (!value) return ''
      value = value.split(".")[0].length > 5 ?  value.substring(0,6) + '...' + value.split(".").pop() : value
      return value
    }
  },
  computed: {
    ...mapGetters(["resource", "language", "AppConfig"]),
    SubscriptionModuleId() {
      return parseInt(this.$f7route.params.Id)
    },
    randomNo() {
      return Helper.getRandomInt()
    },
    fileuploaderId() {
      return "file-uploader" + this.randomNo
    },
    defaultFileType () {
      return this.types
    },
    IsNullOrEmptyErrorMessage() {
      if (this.required && !Helper.IsNullOrEmpty(this.filename)) {
        return true;
      }
    }
  },
  methods: {
    async handleSelects(e) {
      if (Helper.IsUserActionAllow()) {
        this.$emit("propChange", { errorMessage:  '' })
        if (e.target.files.length > 0) {
          this.chkFileFormat = false
          this.filename = e.target.files[0].name;
          this.CheckJPGFormat()
          let type = e.target.files[0].type === 'image/jpeg' ?  ((this.filename.toLowerCase().includes('jpg') || this.filename.toLowerCase().includes('jpeg')) ? 'image/jpeg' : '') : e.target.files[0].type
          if (this.types.includes(type)) {

            var formData = new FormData()
            formData.append('CustomCodeFiles', e.target.files[0])
            formData.append('Subscription_GUID', this.AppConfig.Subscription_GUID)
            formData.append('FolderName', this.SubscriptionModuleId)
            formData.append('CustomCodeFileName', this.filename)
            let uploaded = await Helper.UploadFilestoServer(formData, this)
            if (uploaded) {
              this.$emit("propChange", { value:  '<a target="_blank" style="color: #9e9e9e; font-size: 16px;" href="' + this.AppConfig.Urls.ContentAssetsBaseUrl + this.filename + '">' + this.filename + '</a>', label: this.label })
            }else{
              console.log('Not Uploaded')
            }
          } else {
            this.filename  = ''
            this.$emit("propChange", { errorMessage:  this.resource.str_file_error })
          }
        }
      } else {
        let modalOptions = {
          title: this.resource.warningTitle,
          text: this.resource.warningMessage,
          buttonText: this.resource.closeBtn,
          downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
          $f7: this.$f7
        }
        this.$showModal(modalOptions)
      }
    },
    CheckJPGFormat () {
      console.log('CheckJPGFormat')
      if (this.types.includes('image/jpg')) {
      this.types.push('image/jpeg')
    }
    },
    IsDevSim() {
      return Helper.IsDevSim()
    },
    checkFileName () {
      return this.filename !== ''
    },
    closeBtnclick () {
      if (!Helper.IsDevSim()) {
        let payload = {
          'FileName' : this.filename,
          'Subscription_GUID': this.AppConfig.Subscription_GUID,
          'FolderName': this.SubscriptionModuleId,
        }
        this.filename = ''
        this.$emit("propChange", { value:  '' })
        Helper.RemoveFilesfrmServer(payload, this)
      }
    }
  }
};
</script>
<template>
  <div class="list inline-labels no-hairlines-md">
    <ul class="file-upload-box">
      <li class="item-conten">
        <label class="label-color">{{label}}</label>
        <div class="item-inner">
          <div class="item-input-wrap">
            <label :for="fileuploaderId" v-if="filename" class="custom-file-upload">{{filename | splitFileName }}</label>
            <label :for="fileuploaderId" v-else class="custom-file-upload">{{resource.str_add_File}}</label>
            <input
              class="filedisplay"
              :id="fileuploaderId"
              :ref="fileuploaderId"
              :disabled="checkFileName()"
              @change="handleSelects"
              type="file"
              name="images"/>
            <span v-if="filename"  @click="closeBtnclick()" class="input-clear-button close-icon">
            </span>
          </div>
        </div>
        <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
      </li>
    </ul>
  </div>
</template>
<style scoped>
.input-clear-button {
  width: 10px;
  height: 10px;
  margin-top: -12px !important;
  top: 30px !important;
}
input[type="file" i] {
  display: none;
}
.list {
  margin: 15px 0;
}
.item-label {
  line-height: 15px !important;
  overflow-wrap: break-word !important;
  white-space: pre-wrap !important;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 7px 12px;
  cursor: pointer;
  border-radius: 8px;
  flex: 1;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.file-upload-box {
  padding: 10px 20px;
  background-color: transparent !important;
  font-size: 13px;
}
.file-upload-box > label {
  display: block;
  margin-bottom: 12px;
}
.file-upload-box .item-input-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.file-upload-box .item-input-wrap .input-clear-button {
  width: 32px;
  height: 32px;
  margin-top: 0 !important;
  top: 0px !important;
  border-radius: 8px !important;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  margin-left: 8px;
  position: relative;
}
.file-upload-box .item-input-wrap .input-clear-button:after{
  display: none;
}
.file-upload-box .item-inner {
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/Upload.vue